<template>
    <v-col
        :class="`dsp-header__cta-container ${$vuetify.breakpoint.smOnly ? 'mt-3' : ''}`"
        cols="12"
        md="6">
        <v-card
            max-width="600px"
            class="dsp-header__cta secondaryLighten2 elevation-0">
            <v-card-title>Stay up to date with the latest in digital advertising from DSPolitical</v-card-title>
            <v-card-text>
                <mailchip-embed></mailchip-embed>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import mailchipEmbed from "./mailchimpEmbed";
export default {
    name: "call-to-action",
    components: {
        mailchipEmbed
    }
}
</script>

<style lang="scss">
@import "../../styles/_variables.scss";
.dsp-header {
    &__cta-container {
        max-width: 500px;
    }

    &__cta {
        .v-card__title {
            font-size: 14px;
            line-height: 16px;
            color: $secondary;
            font-weight: bold;
            word-break: normal;
        }

        .v-card__text {
            min-height: 50px;
        }
    }
}
</style>